import(/* webpackMode: "eager" */ "/app/apps/web/src/app/(marketing)/industries/livestock-farming/page.tsx");
